/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 21:39:43 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-05-16 15:12:11
 */

import {moduleName} from "./constants"

export const getCalendars = (state) => (state[moduleName])